import { io } from "socket.io-client";
import { TypedSocket } from "./socketTypes";

const SOCKET_URL = process.env.NEXT_PUBLIC_WS_URL;

export const createClientSocket = (): TypedSocket => {
  return io(SOCKET_URL, {
    autoConnect: false,
    reconnection: true,
    withCredentials: true,
    reconnectionDelay: 1_000,
    reconnectionDelayMax: 10_000,
    reconnectionAttempts: Infinity,
    // Polling FIRST (socket.io default). With websocket listed first, a failed
    // websocket handshake (proxy/CDN edge) does NOT fall back to polling in
    // socket.io v4 — the socket never connects and no realtime event (balance,
    // sportEventsChanged invalidation, ...) is ever delivered. Proven in the
    // 2026-06-11 production incident; do not reorder.
    transports: ["polling", "websocket"],
  });
};
